import {
  IChatUiMessage,
  hasServerId,
} from 'src/api/queries/chat/useChatConversationQueries';

export const FEEDBACK_RATING_UP = 'up';
export const FEEDBACK_RATING_DOWN = 'down';

/** Mirrors the server's reason list; the API rejects any other value. */
export const FEEDBACK_REASONS: { value: string; label: string }[] = [
  { value: 'wrong_data', label: 'Wrong data' },
  { value: 'missing_data', label: 'Missing data' },
  { value: 'misunderstood', label: 'Did not understand' },
  { value: 'too_slow', label: 'Too slow' },
  { value: 'formatting', label: 'Formatting or layout' },
  { value: 'other', label: 'Other' },
];

export const FEEDBACK_COMMENT_MAX_LENGTH = 1000;

/** Falls back to the raw code for a reason this client does not know. */
export const feedbackReasonLabel = (reason: string): string =>
  FEEDBACK_REASONS.find((option) => option.value === reason)?.label ?? reason;

/** @registry True when an assistant reply can take a thumbs vote: finished, not failed, and carrying its persisted server id (a stopped reply keeps its local id until the conversation reloads, and the API answers 404 for that id). */
export const canRateMessage = (message: IChatUiMessage): boolean =>
  message.role === 'assistant' &&
  !message.streaming &&
  message.interruption !== 'failed' &&
  message.stopReason !== 'error' &&
  hasServerId(message);
